(function () {
  function inject() {
    const match = window.location.href.match(/subscriptions\/(\d+)/);
    if (!match) return;

    const contractId = match[1];

    const buttons = document.querySelectorAll("button");

    let cancelBtn = null;

    buttons.forEach(btn => {
      const span = btn.querySelector("span");
      if (span && span.textContent.trim() === "Cancel Subscription") {
        cancelBtn = btn;
      }
    });

    if (!cancelBtn || !cancelBtn.parentNode) return;

    // prevent duplicate
    if (document.getElementById("eva-cancel-btn")) return;

    // 🔴 hide Appstle button
    cancelBtn.style.display = "none";

    // 🟢 clone button (keeps styling)
    const evaBtn = cancelBtn.cloneNode(true);
    evaBtn.id = "eva-cancel-btn";

    const span = evaBtn.querySelector("span");
    if (span) span.textContent = "Cancel Subscription";

    evaBtn.onclick = function () {
      window.location.href =
        "https://subscription-cancellations-503920625202.australia-southeast1.run.app/cancel-start?contractId=" +
        contractId +
        "&returnTo=" +
        encodeURIComponent(window.location.href);
    };

    cancelBtn.parentNode.appendChild(evaBtn);

    console.log("✅ EVA button injected", contractId);
  }

  // 🔥 CRITICAL: keep re-injecting because Appstle re-renders
  setInterval(inject, 1000);

  new MutationObserver(inject).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();